import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';

const AiReportCount = ({ data = {} }) => {
  const stats = [
    {
      label: 'Live Calls',
      value: data.total_live_call_count ?? 0,
      icon: <Icon.Activity size={18} />,
      color: '#2cabe3'
    },
    {
      label: 'Concurrent Calls',
      value: data.total_concurrent_call ?? 0,
      icon: <Icon.PhoneCall size={18} />,
      color: '#2cd07e'
    },
    {
      label: "Today's Calls",
      value: data.today_total_call ?? 0,
      icon: <Icon.Phone size={18} />,
      color: '#6376ff'
    },
    {
      label: "Today's Used Credit",
      value: data.total_today_used_credit ?? 0,
      icon: <Icon.Zap size={18} />,
      color: '#ffb22b'
    },
    {
      label: 'Total Credit',
      value: data.total_credit ?? 0,
      icon: <Icon.CreditCard size={18} />,
      color: '#775dd0'
    },
    {
      label: 'Used Credit',
      value: data.used_credit ?? 0,
      icon: <Icon.DollarSign size={18} />,
      color: '#ff4560'
    },
    {
      label: 'Pending Credit',
      value: data.pending_credit ?? 0,
      icon: <Icon.PieChart size={18} />,
      color: '#00bcd4'
    }
  ];

  return (
    <div className="report-container">
      <div className="d-flex flex-wrap gap-2 align-items-stretch">
        {stats.map((stat, index) => (
          <div key={index} style={{ flex: '1 1 160px', minWidth: '150px' }}>
            <Card
              className="report-card px-2"
              style={{
                borderBottom: `2px solid ${stat.color}`,
                background: `${stat.color}33`,
                height: 'auto',
                minHeight: '60px'
              }}>
              <div className="card-icon flex-shrink-0" style={{ backgroundColor: stat.color }}>
                <div className="icon mr-2 fs-5" style={{ color: 'white' }}>
                  {stat.icon}
                </div>
              </div>
              <div className="d-flex flex-column ps-2" style={{ minWidth: 0 }}>
                <span
                  className="fs-6"
                  style={{ whiteSpace: 'normal', textWrap: 'wrap', lineHeight: 1.15 }}>
                  {stat.label}
                </span>
                <span className="fs-4">{stat.value}</span>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

AiReportCount.propTypes = {
  data: PropTypes.object
};

export default AiReportCount;
